import { render, staticRenderFns } from "./down_file.vue?vue&type=template&id=637c358e&scoped=true&"
import script from "./down_file.vue?vue&type=script&lang=js&"
export * from "./down_file.vue?vue&type=script&lang=js&"
import style0 from "./down_file.vue?vue&type=style&index=0&id=637c358e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637c358e",
  null
  
)

export default component.exports